// =========================================================
// API CONFIGURATION
// ---------------------------------------------------------
// Centralise toutes les routes API du frontend.
//
// Règle clé :
// → le frontend n’utilise QUE des routes relatives (/api)
// → le routage réel est géré par :
//    - proxy React en local
//    - Nginx en production
// =========================================================

const API_BASE_URL = "/api";

// =========================================================
// 🔹 SECTION : PROJETS
// ---------------------------------------------------------
// Gestion complète des projets (CRUD)
// =========================================================
export const PROJECTS_API = {
  base: `${API_BASE_URL}/projects`,     // base CRUD
  getAll: `${API_BASE_URL}/projects`,   // GET : liste des projets
  byId: (id) => `${API_BASE_URL}/projects/${id}`, // GET / PUT / DELETE
};

// =========================================================
// 🔹 SECTION : UTILISATEURS DE PROJET
// ---------------------------------------------------------
// Gestion des membres d’un projet
// =========================================================
export const PROJECT_USERS_API = {
  base: `${API_BASE_URL}/projectusers`,
  byProject: (projectId) => `${API_BASE_URL}/projectusers/${projectId}`, // GET membres
  add: `${API_BASE_URL}/projectusers/add`,             // POST ajout membres
  updateRoles: `${API_BASE_URL}/projectusers/updateRoles`, // PUT rôles
  remove: (projectId, userId) =>
    `${API_BASE_URL}/projectusers/${projectId}/${userId}`, // DELETE membre
};

// =========================================================
// 🔹 SECTION : ACCOUNT (STRUCTURE ORGANISATION)
// ---------------------------------------------------------
// Données globales du compte (entreprise, admin, etc.)
// =========================================================
export const ACCOUNTS_API = {
  base: `${API_BASE_URL}/accounts`,

  // GET : récupérer les infos du compte
  get: `${API_BASE_URL}/accounts`,

  // POST/PUT : mise à jour du compte
  update: `${API_BASE_URL}/accounts`,

  // GET : utilisateurs liés au compte
  allUsers: `${API_BASE_URL}/accounts/users`,
};

export const ACCOUNT_PROFILE_API = {
  get: `${API_BASE_URL}/accounts/profile`,
  update: `${API_BASE_URL}/accounts/profile`,
};

// =========================================================
// 🔹 SECTION : UTILISATEURS GLOBAUX
// ---------------------------------------------------------
// Gestion globale des utilisateurs (indépendant des projets)
// =========================================================
export const USERS_API = {
  base: `${API_BASE_URL}/users`,
  getAll: `${API_BASE_URL}/users`,         // GET liste
  byId: (id) => `${API_BASE_URL}/users/${id}`, // GET / PUT / DELETE
};

// =========================================================
// 🔹 EXPORT GLOBAL
// ---------------------------------------------------------
// Point d’entrée unique utilisé dans toute l’application
// =========================================================
export const API_ROUTES = {
  base: API_BASE_URL,
  projects: PROJECTS_API,
  projectUsers: PROJECT_USERS_API,
  accounts: ACCOUNTS_API, // ⚠️ utiliser "accounts" (et pas "account")
  accountProfile: ACCOUNT_PROFILE_API,
  users: USERS_API,
};